import { useEffect, useRef } from 'react';

const CHECK_INTERVAL_MS = 200;

export const useInfiniteScroll = (
  callback: () => void,
  bufferDistance = 100,
  enabled = true,
): void => {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(() => {
    if (!enabled) return;

    const interval = setInterval(() => {
      const scrollBottom =
        document.body.scrollHeight - document.body.offsetHeight;
      const distanceToBottom = scrollBottom - window.scrollY;
      if (distanceToBottom < bufferDistance) callbackRef.current();
    }, CHECK_INTERVAL_MS);

    return () => clearInterval(interval);
  }, [bufferDistance, enabled]);
};
